/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { useRef, useEffect } from 'react';

var usePropRef = function usePropRef(prop) {
  var ref = useRef(prop);
  useEffect(function () {
    ref.current = prop;
  }, [prop]);
  return ref;
};

export { usePropRef };
//# sourceMappingURL=usePropsRef.js.map
